<template>
  <div>
    <div v-if="page.layout.name === 'ECore.Def.DefEnums.plSearch'">
      <AbrSearchPage
        :def="{ form: def, ...page }"
        :model="Model"
      ></AbrSearchPage>
    </div>

    <div v-else-if="page.layout.name === 'ECore.Def.DefEnums.plSection'">
      <AbrFormPage
        :def="{ form: def, ...page }"
        :mode="mode"
        :model="Model"
        :modal="modal"
      ></AbrFormPage>
    </div>

    <div v-else-if="page.layout.name === 'ECore.Def.DefEnums.plCustom'">
      <component
        :is="component"
        :def="{ form: def, ...page }"
        :model="Model"
      ></component>
    </div>
  </div>
</template>

<script>
import AbrSearchPage from "@/components/search/AbrSearchPage";
import AbrFormPage from "@/components/form/AbrFormPage";

export default {
  name: "AbrPageContainer",
  components: { AbrFormPage, AbrSearchPage },
  props: ["def", "model", "mode", "page", "modal"],
  data: function () {
    return {
      Model: this.model,
    };
  },
  computed: {
  
    component() {
      return () =>
        this.page.componentPath && import("@/ext/" + this.page.componentPath);
    },
  },
  created() {
    if(this.page.layout.name === 'ECore.Def.DefEnums.plSearch') {
      this.$set(this.model, 'results', []);
    }
  },
};
</script>
